export default "__VITE_ASSET__Cow9S2RA__"